import { Breadcrumbs, Layout } from '@loadsmart/loadsmart-ui'
import Header from 'atoms/Header'
import useTopNavigationContext from 'hooks/useTopNavigationContext/useTopNavigationContext'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import TemplateOnboard from './TemplateOnboard'
import TemplateOnboardContextWrapper from './TemplateOnboardContext'

export interface TemplateOnboardIndexProps {
  templateId: string
}

function TemplateOnboardIndex() {
  const { templateId } = useParams<TemplateOnboardIndexProps>()

  return (
    <TemplateOnboardContextWrapper templateId={templateId || ''}>
      <TemplateOnboard />
    </TemplateOnboardContextWrapper>
  )
}

export default TemplateOnboardIndex
